import styles from './styles.module.scss';

import { useNavigate } from 'react-router-dom';

export type OptionProps = {
    icon: string;
    alt: string;
    route: string;
};

export const Option = ({ icon, alt, route }: OptionProps) => {
    const navigate = useNavigate();

    const goToRoute = () => {
        navigate(route);
    };

    return (
        <div className={styles.wrapper}>
            <img
                src={icon}
                className={styles.icon}
                draggable={false}
                alt={alt}
                title={alt}
                onClick={goToRoute}
            />
        </div>
    );
};
